import React from "react";
import { Power, Gamepad2, Loader2 } from "lucide-react";
import { Button } from "components/ui/button";

export default function ContestProductControls({
  productActive = false,
  onToggleProductActive,
  togglingProductStatus = false,
  productPlayable = false,
  onToggleProductPlayable,
  togglingPlayableStatus = false,
  accentColor,
}) {
  return (
    <div className="space-y-2">
      {onToggleProductActive && (
        <div className="flex items-center justify-between gap-2 rounded-lg border border-gray-200 dark:border-gray-700 px-2.5 sm:px-3 py-2">
          <div className="min-w-0 flex-1">
            <p className="text-[11px] font-semibold text-gray-900 dark:text-white">
              Contest visibility
            </p>
            <p className="text-[10px] text-gray-500 leading-snug">
              {productActive ? "Active — visible in app" : "Inactive — hidden from app"}
            </p>
          </div>
          <Button
            type="button"
            size="sm"
            variant={productActive ? "default" : "outline"}
            disabled={togglingProductStatus}
            onClick={() => onToggleProductActive(!productActive)}
            className={`h-8 shrink-0 px-2.5 ${productActive ? "text-white" : ""}`}
            style={productActive && accentColor ? { backgroundColor: accentColor } : undefined}
          >
            {togglingProductStatus ? (
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <>
                <Power className="h-3.5 w-3.5 sm:mr-1" />
                <span className="hidden sm:inline">{productActive ? "Active" : "Inactive"}</span>
              </>
            )}
          </Button>
        </div>
      )}

      {onToggleProductPlayable && (
        <div className="flex items-center justify-between gap-2 rounded-lg border border-gray-200 dark:border-gray-700 px-2.5 sm:px-3 py-2">
          <div className="min-w-0 flex-1">
            <p className="text-[11px] font-semibold text-gray-900 dark:text-white">isPlayable</p>
            <p className="text-[10px] text-gray-500 leading-snug">
              {productPlayable
                ? "YES — users can join and play"
                : "NO — play disabled in app"}
            </p>
          </div>
          <Button
            type="button"
            size="sm"
            variant={productPlayable ? "default" : "outline"}
            disabled={togglingPlayableStatus}
            onClick={() => onToggleProductPlayable(!productPlayable)}
            className={`h-8 shrink-0 px-2.5 ${productPlayable ? "text-white bg-green-600 hover:bg-green-700" : ""}`}
          >
            {togglingPlayableStatus ? (
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <>
                <Gamepad2 className="h-3.5 w-3.5 sm:mr-1" />
                <span>{productPlayable ? "YES" : "NO"}</span>
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  );
}
